// eslint-disable-next-line import/no-cycle
import store from '@/store';
import { Role } from '@/utils/auth';
import PassThrough from '@/components/PassThrough.vue';
import { TAXON_TYPE } from '@/constants/purchase';

const TAnalyticsDashboardPage = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/TAnalyticsDashboard').then(({ TAnalyticsDashboard }) => TAnalyticsDashboard);

const DashboardRoot = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/DashboardRoot.vue');
const Dashboard = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/Dashboard.vue');

const destination = () => import(/* webpackChunkName: "group-dashboard" */ '@/utils/to');

const Links = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/my-page/Links.vue');
const Design = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/my-page/Design.vue');

const EditorRoot = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/editors/EditorRoot.vue');

// My Contacts
const ContactDashboard = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/my-contacts/ContactDashboard');
const CreatorSchoolBase = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/creator-school/CreatorSchoolBase.vue');

// Settings
const PaymentSettings = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/settings/PaymentSettings.vue');
const AccountSettings = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/settings/AccountSettings.vue');

// My Purchases
const PurchaseDashboard = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/my-purchases/PurchaseDashboard.vue');

const ArticleEditor = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/ArticleEditor.vue');
const RecipeEditor = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/RecipeEditor.vue');
const ListEditor = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/ListEditor.vue');
const PodcastEditor = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/PodcastEditor.vue');
const VideoEditor = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/VideoEditor.vue');
const PaidContentSettings = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/PaidContentSettings.vue');
// import PaidContentClaims from '@/pages/editors/PaidContentClaims.vue';
const ExtrasClaims = () => import(/* webpackChunkName: "group-editor" */ '@/pages/dashboard/extras/ExtrasClaims.vue');
const CourseEditor = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/CourseEditor.vue');
const ModuleEditor = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/ModuleEditor.vue');
const OneOffEventEditor = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/OneOffEventEditor.vue');
const SupporterAccountSettings = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/settings/SupporterAccountSettings.vue');
const FileUploadEditor = () => import(/* webpackChunkName: "group-editor" */ '@/pages/editors/FileUploadEditor');
const LearnAndSupportPage = () => import(/* webpackChunkName: "group-dashboard" */ '@/components/creator-school/learnAndSupport/LearnAndSupportPage');

const DashboardTemplates = () => import(/* webpackChunkName: "group-dashboard" */ '@/pages/dashboard/my-page/DashboardTemplates.vue');

export default {
  path: '/dashboard',
  name: 'DashboardRoot',
  component: DashboardRoot,
  async beforeEnter(to, from, next) {
    try {
      await store.dispatch('school/user/findStudent');
      next();
    } catch (e) {
      next();
    }
  },
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: 'supporter',
      name: 'SupporterDashboard',
      redirect: { name: 'SupporterDashboardAccount' },
      component: Dashboard,
      meta: {
        isSupporterShouldBe: true,
      },
      children: [
        {
          path: 'account',
          name: 'SupporterDashboardAccount',
          component: SupporterAccountSettings,
        },
        {
          path: 'purchases',
          name: 'SupporterDashboardPurchases',
          component: PassThrough,
          redirect: { name: 'SupporterDashboardPurchasesAllPurchases' },
          children: [
            {
              path: 'all-purchases',
              name: 'SupporterDashboardPurchasesAllPurchases',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [
                  TAXON_TYPE.SUBSCRIPTION,
                  TAXON_TYPE.COURSE,
                  TAXON_TYPE.DIGITAL_ITEM,
                  TAXON_TYPE.TIP,
                ],
              },
            },
            {
              path: 'subscriptions',
              name: 'SupporterDashboardPurchasesAllSubscriptions',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.SUBSCRIPTION],
              },
            },
            {
              path: 'supporting',
              name: 'SupporterDashboardPurchasesSupporting',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.TIP],
              },
            },
            {
              path: 'digital-items',
              name: 'SupporterDashboardPurchasesDigitalItems',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.DIGITAL_ITEM],
              },
            },
            {
              path: 'courses',
              name: 'SupporterDashboardPurchasesCourses',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.COURSE],
              },
            },
          ],
        },
      ],
    },
    {
      path: '',
      name: 'Dashboard',
      component: Dashboard,
      redirect: { name: 'Links' },
      meta: {
        isSupporterShouldBe: false,
      },
      children: [
        {
          path: 'contacts',
          name: 'Contacts',
          component: PassThrough,
          redirect: { name: 'ContactsSubscribers' },
          children: [
            {
              path: 'all-contacts',
              name: 'AllContacts',
              component: ContactDashboard,
              meta: {
                taxonTypes: [
                  TAXON_TYPE.COURSE,
                  TAXON_TYPE.DIGITAL_ITEM,
                  TAXON_TYPE.EMAIL_CAPTURE,
                  TAXON_TYPE.SUBSCRIPTION,
                  TAXON_TYPE.TIP,
                ],
                exportButtonName: 'Export All contacts',
                fileName: 'contacts_all',
              },
            },
            {
              path: 'email-captures',
              name: 'EmailCaptures',
              component: ContactDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.EMAIL_CAPTURE],
                exportButtonName: 'Export Email captures',
                fileName: 'contacts_email_captures',
              },
            },
            {
              path: 'subscribers',
              name: 'ContactsSubscribers',
              component: ContactDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.SUBSCRIPTION],
                exportButtonName: 'Export Subscribers',
                fileName: 'contacts_subscribers',
              },
            },
            {
              path: 'course-attendees',
              name: 'ContactsCourseAttendees',
              component: ContactDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.COURSE],
                exportButtonName: 'Export Course attendees',
                fileName: 'contacts_course_attendees',
              },
            },
            {
              path: 'supporters',
              name: 'Supporters',
              component: ContactDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.TIP],
                exportButtonName: 'Export Tips',
                fileName: 'contacts_tips',
              },
            },
            {
              path: 'digital-item-claimers',
              name: 'DigitalItemClaimers',
              component: ContactDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.DIGITAL_ITEM],
                exportButtonName: 'Export Digital items',
                fileName: 'contacts_digital_items',
              },
            },
          ],
        },
        {
          path: 'purchases',
          name: 'Purchases',
          component: PassThrough,
          redirect: { name: 'PurchasesSubscriptions' },
          children: [
            {
              path: 'all-purchases',
              name: 'AllPurchases',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [
                  TAXON_TYPE.SUBSCRIPTION,
                  TAXON_TYPE.COURSE,
                  TAXON_TYPE.DIGITAL_ITEM,
                  TAXON_TYPE.TIP,
                ],
              },
            },
            {
              path: 'subscriptions',
              name: 'PurchasesSubscriptions',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.SUBSCRIPTION],
              },
            },
            {
              path: 'supporting',
              name: 'Supporting',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.TIP],
              },
            },
            {
              path: 'digital-items',
              name: 'DigitalItems',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.DIGITAL_ITEM],
              },
            },
            {
              path: 'courses',
              name: 'PurchasesCourses',
              component: PurchaseDashboard,
              meta: {
                taxonTypes: [TAXON_TYPE.COURSE],
              },
            },
          ],
        },

        {
          path: 'links',
          name: 'Links',
          component: Links,
        },
        {
          path: 'templates',
          name: 'Templates',
          component: DashboardTemplates,
        },
        {
          path: 'design',
          name: 'Design',
          component: Design,
        },
        {
          path: 'analytics',
          name: 'Analytics',
          component: TAnalyticsDashboardPage,
          beforeEnter(t, from, next) {
            const role = store.getters['auth/role'];
            if (role === Role.GUEST) {
              next(destination('AccountSettings'));
              return;
            }

            next();
          },
        },
        {
          path: 'account',
          name: 'AccountSettings',
          component: AccountSettings,
        },
        {
          path: 'payment-settings',
          name: 'PaymentSettings',
          component: PaymentSettings,
        },
        {
          path: 'creator-school/:id/:section',
          name: 'creator-school',
          component: CreatorSchoolBase,
          props: true,
          beforeEnter: async (to, from, next) => {
            await store.commit('school/user/setCourseId', to.params.id);
            next();
          },
        },
        {
          path: 'learn-and-support',
          name: 'LearnAndSupport',
          component: LearnAndSupportPage,
        },
      ],
    },
    {
      path: 'editor',
      name: 'EditorRoot',
      component: EditorRoot,
      meta: {
        isSupporterShouldBe: false,
      },
      children: [
        {
          path: 'article/:id',
          name: 'ArticleEditor',
          component: ArticleEditor,
          meta: {
            editor: 'Article',
          },
        },
        {
          path: 'file/:id',
          name: 'FileUploadEditor',
          component: FileUploadEditor,
          meta: {
            editor: 'File',
          },
        },
        {
          path: 'recipe/:id',
          name: 'RecipeEditor',
          component: RecipeEditor,
          meta: {
            editor: 'Step by Step Guide',
          },
        },
        {
          path: 'list/:id',
          name: 'ListEditor',
          component: ListEditor,
          meta: {
            editor: 'List',
          },
        },
        {
          path: 'podcast/:id',
          name: 'PodcastEditor',
          component: PodcastEditor,
          meta: {
            editor: 'Podcast',
          },
        },
        {
          path: 'video/:id',
          name: 'VideoEditor',
          component: VideoEditor,
          meta: {
            editor: 'Video',
          },
        },
        {
          path: 'item/:id',
          name: 'DigitalItemEditor',
          component: PassThrough,
          redirect: { name: 'PaidContentSettings' },
          meta: {
            editor: 'Digital Item',
            tabs: [
              {
                to: { name: 'PaidContentSettings' },
                name: 'Settings',
              },
              {
                to: { name: 'PaidContentClaims' },
                name: 'Claims',
              },
            ],
          },
          children: [
            {
              path: '',
              name: 'PaidContentSettings',
              component: PaidContentSettings,
              meta: {
                name: 'Settings',
              },
            },
            {
              path: 'claims',
              name: 'PaidContentClaims',
              component: ExtrasClaims,
              props: true,
              meta: {
                name: 'Claims',
              },
            },
          ],
        },
        {
          path: 'course/:id',
          name: 'CourseEditor',
          component: PassThrough,
          redirect: { name: 'CourseSettings' },
          meta: {
            editor: 'Course',
            tabs: [
              {
                to: { name: 'CourseSettings' },
                name: 'Settings',
              },
              {
                to: { name: 'Classroom' },
                name: 'Classroom',
              },
            ],
          },
          children: [
            {
              path: '',
              name: 'CourseSettings',
              component: CourseEditor,
              meta: {
                name: 'Settings',
              },
            },
            {
              path: 'classroom',
              name: 'Classroom',
              component: ExtrasClaims,
              props: true,
              meta: {
                name: 'Claims',
              },
            },
          ],
        },
        {
          path: 'module/:id',
          name: 'ContentModuleEditor',
          component: ModuleEditor,
          meta: {
            editor: 'Module',
          },
        },
        {
          path: 'one-off-event/:id',
          name: 'OneOffEventEditor',
          component: PassThrough,
          redirect: { name: 'oneOffEventEditor' },
          meta: {
            editor: 'Digital Event',
            tabs: [
              {
                to: { name: 'oneOffEventEditor' },
                name: 'Settings',
              },
              {
                to: { name: 'oneOffEventClaims' },
                name: 'Claims',
              },
            ],
          },
          children: [
            {
              path: '',
              name: 'oneOffEventEditor',
              component: OneOffEventEditor,
              meta: {
                name: 'Settings',
              },
            },
            {
              path: 'claims',
              name: 'oneOffEventClaims',
              component: ExtrasClaims,
              props: true,
              meta: {
                name: 'Claims',
              },
            },
          ],

        },
      ]
        .map((route) => {
          route.meta.dashboardTab = 'Links';
          return route;
        }),
    },
  ],
};
